export enum LicenseStatusBarState {
  None = 'NONE',
  FreeTrial = 'FREE_TRIAL',
  FreeTrialLessThan7DaysLeft = 'FREE_TRIAL_LESS_THAN_7_DAYS_LEFT',
  FreeTrialLessThan3DaysLeft = 'FREE_TRIAL_LESS_THAN_3_DAYS_LEFT',
  FreeTrialOver = 'FREE_TRIAL_OVER',

  LessThan7DaysLeft = 'LESS_THAN_7_DAYS_LEFT',
  LessThan3DaysLeft = 'LESS_THAN_3_DAYS_LEFT',
  Suspended = 'SUSPENDED',
  Active = 'ACTIVE',
}